import React, { Component } from 'react'

import StyleguidePreview from 'components/styleguide-preview'
import EditableField from 'components/editable-field'

import EyeIcon from '../../../assets/icons/eye.svg'

class EditableFields extends Component {

  constructor(props) {
    super(props)

    this.state = {
      editable: false,
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange() {
    this.setState({
      editable: !this.state.editable,
    })
  }

  render() {
    const { editable } = this.state

    return (
      <StyleguidePreview
        description="A magic editable input field"
        spacing="vertical"
        title="Editable Field"
      >
        <div>
          <label htmlFor={"checkbox_id"}>
            <input id="checkbox_id" type="checkbox" onChange={this.handleChange} /> Editable
          </label>
        </div>
        <EditableField value="primary important" editable={editable} primary important />
        <EditableField value="primary" editable={editable} primary />
        <EditableField value="secondary important" editable={editable} important />
        <EditableField value="secondary" editable={editable} />
        <EditableField label="label" value="label" editable={editable} />
        <EditableField label="label" icon={<EyeIcon />} value="icon" editable={editable} />
        <EditableField label="label" prefix="prefix" value="prefix" editable={editable} />
        <EditableField label="label" type="textarea" value="textarea" editable={editable} />
      </StyleguidePreview>
    )
  }

}

export default EditableFields



/** WEBPACK FOOTER **
 ** ./src/containers/styleguide/editable-fields.js
 **/